import { render, staticRenderFns } from "./v-navbar-notifications-item.vue?vue&type=template&id=1bbe0a4c&scoped=true&"
import script from "./v-navbar-notifications-item.vue?vue&type=script&lang=js&"
export * from "./v-navbar-notifications-item.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar-notifications-item.vue?vue&type=style&index=0&id=1bbe0a4c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbe0a4c",
  null
  
)

export default component.exports